import { useMemo } from "react";
import { Grid, Paper } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { JobPhase } from "generated/graphql";
import { jobMeasurementPlurals } from "utils/product-types/getJobMeasurementMethodOptions";

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <MDBox
      display="grid"
      gridTemplateColumns="112px minmax(0, 1fr)"
      columnGap={1.25}
      alignItems="start"
      sx={{
        py: 0.35,
        borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
        "&:last-of-type": {
          borderBottom: "none",
          pb: 0,
        },
        "@media print": {
          gridTemplateColumns: "90px minmax(0, 1fr)",
          columnGap: 0.75,
          py: 0.2,
        },
      }}
    >
      <MDTypography
        variant="caption"
        fontWeight="bold"
        sx={{ lineHeight: 1.1, color: "#000" }}
      >
        {label}
      </MDTypography>
      <MDTypography
        variant="button"
        color="dark"
        sx={{
          display: "block",
          lineHeight: 1.2,
          wordBreak: "break-word",
          fontWeight: 500,
          textAlign: "right",
        }}
      >
        {value}
      </MDTypography>
    </MDBox>
  );
}

export default function ProductDetails({ phase }: { phase: JobPhase }) {
  const { address, jobSize, scheduleBlocks, organizationProductTypeName, proposalProduct } = phase;

  const totalHours = useMemo(() => {
    return scheduleBlocks?.length
      ? scheduleBlocks?.map((x) => x.blockLength)?.reduce((a, b) => a + b)
      : 0;
  }, [scheduleBlocks]);

  return (
    <Grid item className="no-break">
      <MDBox height="100%" width="100%">
        <Paper
          sx={{
            p: 1.25,
            borderRadius: 1.5,
            backgroundColor: "#fff",
            border: "1px solid rgba(0, 0, 0, 0.08)",
            height: "100%",
            width: "100%",
          }}
        >
          <MDBox>
            <InfoRow label="Category" value={organizationProductTypeName || "—"} />
            <InfoRow label="Product" value={proposalProduct?.productName || "—"} />
            <InfoRow label="Job Address" value={address || "—"} />
            <InfoRow
              label="Job Size"
              value={`${jobSize} ${jobMeasurementPlurals[proposalProduct?.measurementJob] || ""}`.trim()}
            />
            <InfoRow
              label="Job Hours"
              value={`${(totalHours ?? 0).toFixed(2)} hour${totalHours > 1 ? "s" : ""}`}
            />
          </MDBox>
        </Paper>
      </MDBox>
    </Grid>
  );
}
